import { Group, Slider, Stack, TextInput } from '@ekhodealer/ekho-common/rev';

import type { TextInputProps } from '@ekhodealer/ekho-common/rev';

export function RangeInput(props: {
	type: TextInputProps['type'];
	ranges: {
		min: {
			limit: number;
			label: string;
			placeholder: string;
		};
		max: {
			limit: number;
			label: string;
			placeholder: string;
		};
	};
	value: { min: number; max: number };
	onChange: (range: { min: number; max: number }) => void;
	step?: number;
	mask?: string;
	maskAllowedChars?: RegExp;
	leftContent?: React.ReactNode;
	rightContent?: React.ReactNode;
	isReadOnly?: boolean;
	isRequired?: boolean;
}) {
	const getClampedValue = (value: string | number) => {
		const parsedValue = parseFloat(`${value}`);
		if (Number.isNaN(parsedValue)) {
			return props.ranges.min.limit;
		}

		return Math.max(props.ranges.min.limit, Math.min(parsedValue, props.ranges.max.limit));
	};

	const handlePostProcessClamp = () => {
		const clampedValue = {
			min: getClampedValue(props.value.min),
			max: getClampedValue(props.value.max),
		};

		// Ensure max is not less than min
		if (clampedValue.max < clampedValue.min) {
			const temp = clampedValue.max;
			clampedValue.max = clampedValue.min;
			clampedValue.min = temp;
		}

		props.onChange(clampedValue);
	};

	return (
		<Stack itemsSpacing='12'>
			<Group itemsSpacing='8' itemsAlignX='stretch'>
				<TextInput
					label={props.ranges.min.label}
					value={props.value.min.toString()}
					onChange={(value) => {
						props.onChange({
							min: parseFloat(value),
							max: props.value.max,
						});
					}}
					onBlur={handlePostProcessClamp}
					type={props.type}
					mask={props.mask ?? '*'}
					maskAllowedChars={props.maskAllowedChars ?? /[\d|,]/}
					placeholder={props.ranges.min.placeholder}
					isRequired={props.isRequired}
					isReadOnly={props.isReadOnly}
					leftContent={props.leftContent}
					rightContent={props.rightContent}
				/>
				<TextInput
					label={props.ranges.max.label}
					value={props.value.max.toString()}
					onChange={(value) => {
						props.onChange({
							min: props.value.min,
							max: parseFloat(value),
						});
					}}
					onBlur={handlePostProcessClamp}
					type={props.type}
					mask={props.mask ?? '*'}
					maskAllowedChars={props.maskAllowedChars ?? /[\d|,]/}
					placeholder={props.ranges.max.placeholder}
					isRequired={props.isRequired}
					isReadOnly={props.isReadOnly}
					leftContent={props.leftContent}
					rightContent={props.rightContent}
				/>
			</Group>

			{/* Stack makes space for the slider hover effect */}
			<Stack padding={{ x: '12', b: '12' }}>
				<Slider
					value={[props.value.min, props.value.max]}
					onChange={([min, max]) => {
						props.onChange({ min, max });
					}}
					minValue={props.ranges.min.limit}
					maxValue={props.ranges.max.limit}
					step={props.step}
				/>
			</Stack>
		</Stack>
	);
}
